import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { UserX, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaRecusaProfissional = (acao: string): boolean => {
    if (!acao) return false;
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes("recusou proposta");
};

const getIconRecusaProfissional = (): { Icon: LucideIcon; color: string } => {
    return { Icon: UserX, color: "var(--cdc2626)" };
};

export default function CardRecusaProfissional({
    item,
    onNavigateToFile,
    isExpanded,
    onToggleExpand
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconRecusaProfissional()}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const recusaProfissionalConfig = {
    tipo: "recusa_profissional",
    detectaTipo: detectaRecusaProfissional,
    getIcon: getIconRecusaProfissional,
    temExpansao: () => true,
    Component: CardRecusaProfissional
};

